import * as React from 'react';

function SvgCaretDown(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M2.357 7.976l8.532 9.956a1.466 1.466 0 002.224 0l8.532-9.956c.814-.95.139-2.418-1.113-2.418H3.467c-1.252 0-1.927 1.468-1.11 2.418z" })));
}

export default SvgCaretDown;
